// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CopyToClipboardText__container-da9d55 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
}

.CopyToClipboardText__button-d99293 {
  font: var(--font-body-5);
  letter-spacing: var(--font-spacing-body-5);
  color: var(--brand-primary-40);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-grow: 1;
  padding-inline-end: 2px;
  text-align: left;
  cursor: pointer;
}

.CopyToClipboardText__button-d99293:hover,
.CopyToClipboardText__button-d99293:focus {
  color: var(--brand-primary-50);
}

.CopyToClipboardText__button-d99293:active {
  color: var(--brand-primary-60);
}`, "",{"version":3,"sources":["webpack://./src/components/CopyToClipboardText/CopyToClipboardText.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,8BAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAEA;;EAEE,8BAAA;AACF;;AAEA;EACE,8BAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  overflow: hidden;\n}\n\n.button {\n  font: var(--font-body-5);\n  letter-spacing: var(--font-spacing-body-5);\n  color: var(--brand-primary-40);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex-grow: 1;\n  padding-inline-end: 2px;\n  text-align: left;\n  cursor: pointer;\n}\n\n.button:hover,\n.button:focus {\n  color: var(--brand-primary-50);\n}\n\n.button:active {\n  color: var(--brand-primary-60);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CopyToClipboardText__container-da9d55`,
	"button": `CopyToClipboardText__button-d99293`
};
module.exports = ___CSS_LOADER_EXPORT___;
